/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceDetails
 */
export interface PriceDetails {
    /**
     * 
     * @type {number}
     * @memberof PriceDetails
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof PriceDetails
     */
    feesType: PriceDetailsFeesTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PriceDetails
     */
    feesValue: number;
}


/**
 * @export
 */
export const PriceDetailsFeesTypeEnum = {
    Flat: 'FLAT',
    Successive: 'SUCCESSIVE',
    Repatriation: 'REPATRIATION'
} as const;
export type PriceDetailsFeesTypeEnum = typeof PriceDetailsFeesTypeEnum[keyof typeof PriceDetailsFeesTypeEnum];


/**
 * Check if a given object implements the PriceDetails interface.
 */
export function instanceOfPriceDetails(value: object): value is PriceDetails {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('feesType' in value) || value['feesType'] === undefined) return false;
    if (!('feesValue' in value) || value['feesValue'] === undefined) return false;
    return true;
}

export function PriceDetailsFromJSON(json: any): PriceDetails {
    return PriceDetailsFromJSONTyped(json, false);
}

export function PriceDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'feesType': json['feesType'],
        'feesValue': json['feesValue'],
    };
}

export function PriceDetailsToJSON(value?: PriceDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'feesType': value['feesType'],
        'feesValue': value['feesValue'],
    };
}

